// @flow

import _ from "lodash";

import type { UserTask } from "../data/user-results";
export type CorrectnessString = "right" | "neutral" | "wrong";

export function isCorrect(confidence: number, answer: boolean): boolean {
  return (confidence > 50) === answer; // prettier-ignore
}

export function correctnessString(
  confidence: number,
  answer: boolean
): CorrectnessString {
  if (confidence === 50) {
    return "neutral";
  }
  return isCorrect(confidence, answer) ? "right" : "wrong"; // prettier-ignore
}

export function correctnessSymbol(confidence: number, answer: boolean): string {
  const s = correctnessString(confidence, answer);
  if (s === "right") {
    return "✓";
  }
  if (s === "neutral") {
    return "~";
  }
  if (s === "wrong") {
    return "✗";
  }
  throw new Error(`Unknown correctness: ${s}`);
}

type Correct = boolean | null;

function correctnessStats(tasks: Array<UserTask>) {
  const cs: Array<Correct> = tasks.map(task => {
    if (task.results.length === 0) {
      return null;
    }
    const result = _.last(task.results);
    if (result.confidence === 50) {
      return null;
    }
    return isCorrect(result.confidence, task.answer);
  });
  const definite = cs.filter(c => c !== null);
  return {
    definite: definite.length,
    indefinite: cs.length - definite.length,
    correct: definite.filter(_.identity).length
  };
}

export default {
  string: correctnessString,
  symbol: correctnessSymbol,
  stats: correctnessStats
};



// WEBPACK FOOTER //
// ./src/utils/correctness.js